var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRepeateMusic = function SvgRepeateMusic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#6777FF",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.118 9.306a.4.4 0 0 1-.287-.12A3.936 3.936 0 0 1 4.604 2.47l3.288.012-.59-.563a.404.404 0 0 1-.011-.575.404.404 0 0 1 .574-.01L9.186 2.6c.12.114.157.293.098.444a.41.41 0 0 1-.38.255l-4.306-.011a3.124 3.124 0 0 0-3.114 3.125c0 .83.325 1.615.915 2.205a.41.41 0 0 1 0 .574.4.4 0 0 1-.281.114M5.416 11.781a.4.4 0 0 1-.282-.114L3.813 10.4a.41.41 0 0 1-.098-.444.41.41 0 0 1 .38-.255l4.306.011a3.124 3.124 0 0 0 3.114-3.125c0-.83-.325-1.615-.915-2.205a.41.41 0 0 1 0-.574.41.41 0 0 1 .574 0 3.936 3.936 0 0 1-2.773 6.717l-3.288-.011.59.563a.404.404 0 0 1 .011.574.42.42 0 0 1-.298.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.125 6.906h-3.25a.41.41 0 0 1-.406-.406.41.41 0 0 1 .406-.406h3.25a.41.41 0 0 1 .406.406.41.41 0 0 1-.406.406"
  }))));
};
export default SvgRepeateMusic;